import { del, get, post, put } from "../axios";
import { responseIsSuccessful } from "../global-helpers";
import { ApiResponseStatus } from "../constants/enums";
import { Crew } from "../models/Crew";
import {
  formatObjectWithNotes,
  formatPhones,
  simpleResponse
} from "./api-helpers";

export async function getCrews() {
  return await get("crews", window.localStorage.apiToken)
    .then(res => {
      let crewsAndCounts = { crews: [], counts: {} };
      if (responseIsSuccessful(res)) {
        if (res.data.crews) {
          crewsAndCounts.crews = res.data.crews.map(c => {
            formatObjectWithNotes(c);
            if (c.crew_supervisor) {
              formatPhones(c.crew_supervisor);
            }
            return new Crew(c);
          });
        }
        if (res.data.counts) {
          crewsAndCounts.counts = res.data.counts;
        }
      }
      return crewsAndCounts;
    })
    .catch(err => {
      console.log(err);
      return { crews: [], counts: {} };
    });
}

export async function storeCrew(crew) {
  return await post(
    "crews",
    { crew_params: crew },
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function updateCrew(crew) {
  return await put(
    `crews/${crew.id}`,
    { crew_params: crew },
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function deleteCrew(crew) {
  return await simpleResponse(
    del(`crews/${crew.id}`, window.localStorage.apiToken)
  );
}
